import {Component, Inject, Input, OnInit} from 'ng-metadata/core';
import {MoreLikeThisService} from './moreLikeThis.service';
import {beacon, PrimolyticsService} from "../../analytics/primolytics.service";
import {SearchService} from "../search.service";
import {PrimoResponse} from "../../infra/dataStructures/PrimoResponses/doc.interfcae";
import {ScrollService} from "../scroller/scroll.service";
import {CollectionDiscoveryService, ICollectionPathObject} from "../../collectionDiscovery/collectionDiscovery.service";
import {STATE_NAMES} from "../../primoExplore/primoExploreStates.module";
import {
    IVirtualBrowseApiParams,
    IVirtualBrowseObject,
    VirtualBrowseItem,
    VirtualBrowseService
} from "../virtualBrowse/virtualBrowse.service";
import {ConfigurationUtil} from "../../nddUtils/configurationUtil.service";
import {SmoothScrollUtil} from "../../nddUtils/smoothScrollUtil.service";
import {ChangeLangService} from "../../infra/lang/changeLang.service";
import {FullViewService} from "../fullView/fullView.service";
import {ServiceDetailsService} from '../fullView/details/serviceDetails.service';
import {getResultsBulkSize,getLegantoTemplateUrl, getInstitutionCode} from "../../appConfig/appConfigForward";

const get = require('lodash/get');
const forEach = require('lodash/forEach');
const indexOf = require('lodash/indexOf');
const findIndex = require('lodash/findIndex');
const identity = require('lodash/identity');
const orderBy = require('lodash/orderBy');

const START_INDEX = 0;
const ITEM_WIDTH = 110; //This is hard coded also in html under md-item-size. No way around this at the moment

@Component({
    selector: 'prm-more-like-this',
    templateUrl: 'components/search/moreLikeThis/more-like-this.html',
})

export class PrmMoreLikeThis implements OnInit {
    private scrollElement: JQuery;
    private LEFT = 'LEFT';
    private RIGHT = 'RIGHT';
    private interval;
    private scrollDirection: string;
    private intervalCounter: number;
    private distance: number;
    private INITIAL_DISTANCE = 3;
    private clickTimeOut;
    private CLICK_TIME = 200;
    private MAX_DISTANCE = 20;
    private nextBeaconCalledOnce: boolean = false;
    private previousBeaconCalledOnce: boolean = false;
    @Input() private item: PrimoResponse.IDoc;
    private nextOffset: number;
    private totalItems: number;
    @Input() private sameByField: string;
    private externalLinksCollapse: boolean = false;
    @Input() private moreInTheSameCourseItem: any;
    private institution;
    private offseterElem;
    private featuredContent;
    private featuredItems;
    private sameByFields: any;
    private items: any;
    private COLLECTION_DISCOVERY_STATE = STATE_NAMES.COLLECTION_DISCOVERY;
    institution: string;
    private dynamicMoreLikeThisItems: DynamicMoreLikeThisItems;
    private isListFocused: boolean = false;
    private focusedIndex = START_INDEX;
    private servicesToFilter = ['$$R'];
    @Input() private moreLikeThisUnfilteredItems: object;
    private KEY_CODE = {
        COMMA: 188,
        SEMICOLON: 186,
        ENTER: 13,
        ESCAPE: 27,
        SPACE: 32,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        LEFT_ARROW: 37,
        UP_ARROW: 38,
        RIGHT_ARROW: 39,
        DOWN_ARROW: 40,
        TAB: 9,
        BACKSPACE: 8,
        DELETE: 46
    };


    constructor(private moreLikeThisService: MoreLikeThisService,
                @Inject('availabilityLineIcons') private availabilityLineIcons: Object[],
                @Inject('$interval') private $interval: ng.IIntervalService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$q') private $q: ng.IQService,
                private searchService: SearchService,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                private scrollService: ScrollService,
                private collectionDiscoveryService: CollectionDiscoveryService,
                private virtualBrowseService: VirtualBrowseService,
                private changeLangService: ChangeLangService,
                private fullViewService: FullViewService,
                private smoothScrollUtil: SmoothScrollUtil,
                private configurationUtil : ConfigurationUtil,
                private primolyticsService: PrimolyticsService,
                @Inject('$element') private $element,
                private serviceDetailsService : ServiceDetailsService,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$mdDialog') private $mdDialog: angular.material.IDialogService,
                @Inject('$translate') private $translate) {


        this.scrollElement = angular.element(this.$element[0].querySelector("#prm-more-like-this .md-virtual-repeat-scroller"));

    }

    ngOnInit() {
        this.institution = getInstitutionCode();
        this.$stateParams['items'] = undefined; //we do this because of bug in ui-router which causes non url params to not be reset on state reload
        this.moreLikeThisService.itemsSearchInProgress = true;
        this.sameByFields = [];

        if (this.sameByField === 'crs') {
            this.sameByFields = get(this.item, 'pnx.display.crsinfo');
            if (this.changeLangService.direction == 'rtl') {
                this.focusedIndex = this.sameByFields.length;
            }

            let enableLegantoLink;
            let fullViewConfiguration = this.configurationUtil.getFullViewConfiguration();
            if(fullViewConfiguration) {
                enableLegantoLink = fullViewConfiguration.enablelegantolink;
            }

            this.sameByFields = this.sameByFields.map((e) => {
                let courseName = this.serviceDetailsService.getDisplayedCourseCode(e);
                let course = {
                    'name': courseName,
                    'link': this.serviceDetailsService.createLegantoLink(this.item, e),
                    'isLinkable': (enableLegantoLink && e && e.indexOf('$$R')>-1) || getLegantoTemplateUrl(),
                    'tooltip' : this.$translate.instant('nui.aria.moreFromTheSame.course')
                }
                return course;

            });
            this.sameByFields = this.sortByName(this.sameByFields);

        } else if (this.sameByField === 'col') {
            let cdParentIds = get(this.item, 'pnx.search.cdparentid') || this.moreLikeThisService.getCollectionIds(this.item);
            this.$q.all(this.colTitle(cdParentIds)).then((results) => {
                this.sameByFields = results.filter(identity).map((item) => {return this.moreLikeThisStateParams(item)});
                this.sameByFields = this.sortByName(this.sameByFields);

                if (this.changeLangService.direction == 'rtl') {
                    this.focusedIndex = this.sameByFields.length;
                }
            });
        }


        this.nextOffset = this.fullViewService.nextOffset[this.sameByField];
        this.totalItems = this.fullViewService.totalItems[this.sameByField];
        this.items = this.fullViewService.moreLikeThisItems[this.sameByField];
        let firstMoreLikeThisItems = this.moreLikeThisUnfilteredItems[this.sameByField];
        if(firstMoreLikeThisItems && firstMoreLikeThisItems.length > 0){
            this.dynamicMoreLikeThisItems = new DynamicMoreLikeThisItems(this.item, this.virtualBrowseService, this.scrollElement, this.sameByField, this.configurationUtil, this.moreLikeThisService, this.totalItems, firstMoreLikeThisItems);
        }

    }

    get currentIndex() {
        return this.dynamicMoreLikeThisItems.currentIndex;
    }

    set currentIndex(index: number) {
        this.dynamicMoreLikeThisItems.currentIndex = index;
    }

    get dynamicVirtualBrowseItemsLength(){
        return this.dynamicMoreLikeThisItems.getLength();
    }

    public handleKeyUp(e) {
        let keyCodes = this.KEY_CODE;
        switch (e.keyCode) {
            case keyCodes.LEFT_ARROW:
                this.sendScrollDirectionBeacon(this.LEFT);
                break;
            case keyCodes.RIGHT_ARROW:
                this.sendScrollDirectionBeacon(this.RIGHT);
                break;
        }
    }

    get isRightScrollDisabled() {
        if (!this.scrollElement) {
            return false;
        }
        if (this.dynamicMoreLikeThisItems.rightScrollLimit == undefined) {
            return this.scrollElement[0].scrollLeft + this.scrollElement[0].offsetWidth == this.scrollElement[0].scrollWidth;
        }

        return this.scrollElement[0].scrollLeft >= this.dynamicMoreLikeThisItems.rightScrollLimit;
    }

    get isLeftScrollDisabled() {
        if (!this.scrollElement) {
            return false;
        }
        if (!this.dynamicMoreLikeThisItems || !this.dynamicMoreLikeThisItems.leftScrollLimit) {
            return this.scrollElement[0].scrollLeft == 0;
        }
        return this.scrollElement[0].scrollLeft <= this.dynamicMoreLikeThisItems.leftScrollLimit;
    }

    private previous(event) {
        if (event.which === 13) {
            this.scrollListWithClick(this.LEFT);
        }
    }

    private next(event) {
        if (event.which === 13) {
            this.scrollListWithClick(this.RIGHT);
        }
    }

    private scrollListWithClick(direction) {
        this.$interval.cancel(this.interval);
        this.scrollDirection = direction;
        this.smoothScrollClick();
    }

    private smoothScrollClick() {
        let distanceScrolled = 0;
        let clickScrollDistance = 7 * (this.scrollElement[0].offsetWidth / 10);
        if (this.scrollDirection === this.LEFT) {
            clickScrollDistance = -clickScrollDistance;
        }
        let frame = 0;
        let numOfFrames = 60;
        let beginningPos = this.scrollElement[0].scrollLeft;

        this.interval = this.$interval(() => {
            let newPos = this.easeInOutQuart(frame, beginningPos, clickScrollDistance, numOfFrames);
            if (newPos <= this.dynamicMoreLikeThisItems.leftScrollLimit && newPos < this.scrollElement[0].scrollLeft) {
                this.$interval.cancel(this.interval);
                this.scrollElement[0].scrollLeft = this.dynamicMoreLikeThisItems.leftScrollLimit;
                return;
            }
            if (newPos >= this.dynamicMoreLikeThisItems.rightScrollLimit && newPos > this.scrollElement[0].scrollLeft) {
                this.$interval.cancel(this.interval);
                this.scrollElement[0].scrollLeft = this.dynamicMoreLikeThisItems.rightScrollLimit;
                return;
            }
            frame++;
            this.scrollElement[0].scrollLeft = newPos;
            if (frame === numOfFrames) {
                this.$interval.cancel(this.interval);
            }
        }, 2);
    }

    public onItemInView($index, $inview, $inviewInfo) {
        if ($index === this.leftFinalIndex - 1) {
            this.dynamicMoreLikeThisItems.leftScrollLimit = this.dynamicMoreLikeThisItems.leftScrollLimit || this.scrollElement[0].scrollLeft;
        }
        if ($index === this.rightFinalIndex + 1) {
            this.dynamicMoreLikeThisItems.rightScrollLimit = this.dynamicMoreLikeThisItems.rightScrollLimit || this.scrollElement[0].scrollLeft;
        }

    }

    get leftFinalIndex() {
        return this.dynamicMoreLikeThisItems.leftFinalIndex;
    }

    get rightFinalIndex() {
        return this.dynamicMoreLikeThisItems.rightFinalIndex;
    }

    private focusSupport(e) {
        let listElements = angular.element(e.target).parent().children();
        listElements.attr('tabindex', -1);

        if (!this.isListFocused) {
            switch (e.type) {
                case 'focus':
                    this.isListFocused = true;
                    if (angular.element(document.querySelector('#moreFromTheSameID' + this.sameByField + this.focusedIndex)).length) {
                        this.smoothScrollUtil.focusOn('moreFromTheSameID' + this.sameByField + this.focusedIndex);
                    } else {
                        let elementToFocus = listElements[Math.ceil(listElements.length / 2)];
                        this.focusedIndex = Number.parseInt(elementToFocus.id.split('moreFromTheSameID' + this.sameByField)[1]);
                        elementToFocus.focus();
                    }

                    break;
            }
        }
    };

    private focusOutSupport(e) {
        this.isListFocused = false;
        let listElements = angular.element(e.target).parent().children();
        listElements.attr('tabindex', 0);
    }

    private keyDownSupport(e, moreInTheSameCourseItem) {
        let keyCodes = this.KEY_CODE;

        switch (e.keyCode) {
            case keyCodes.UP_ARROW:
            case keyCodes.LEFT_ARROW:
                if (this.focusedIndex > 0) { //only move focus left if we are not currently on the left most index
                    this.focusedIndex--;
                    this.smoothScrollUtil.focusOn('moreFromTheSameID' + this.sameByField + this.focusedIndex);
                }
                break;
            case keyCodes.DOWN_ARROW:
            case keyCodes.RIGHT_ARROW:
                if (this.focusedIndex < this.totalItems) { //only move focus right if we are not currently on the right most index
                    this.focusedIndex++;
                    this.smoothScrollUtil.focusOn('moreFromTheSameID' + this.sameByField + this.focusedIndex);
                }
                break;
            case keyCodes.TAB:
                break;
            case keyCodes.ENTER:
                this.navigateToItemFullView(moreInTheSameCourseItem);
                e.stopPropagation();
        }
    };

    private easeInOutQuart(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t * t * t + b;
        t -= 2;
        return -c / 2 * (t * t * t * t - 2) + b;
    }

    public scrollContent(direction: string) {
        this.sendScrollDirectionBeacon(direction === 'left' ? this.LEFT : this.RIGHT);
        this.scrollService.smoothScrollClick(direction, this.offseterElem, this.featuredItems, 100);
    }
    
    @beacon({ 'p': 'moreFromTheSame', 'op': 'linkToLeganto' })
    private sendLinkToLegantoBeacon() {
    }

    @beacon({'p': 'moreFromTheSame', 'op': 'previousInMoreFromTheSame'})
    private sendPreviousInMoreFromTheSameBeacon() {
    }

    @beacon({'p': 'moreFromTheSame', 'op': 'nextInMoreFromTheSame'})
    private sendNextInMoreFromTheSameBeacon() {
    }
    
    private sendScrollDirectionBeacon(direction) {
        if (!this.previousBeaconCalledOnce && direction === this.LEFT) {
            this.sendPreviousInMoreFromTheSameBeacon();
            this.previousBeaconCalledOnce = true;
        } else if (!this.nextBeaconCalledOnce && direction === this.RIGHT) {
            this.sendNextInMoreFromTheSameBeacon();
            this.nextBeaconCalledOnce = true;
        }
    }

    /*get leftArrowShowing():boolean{
        return this.scrollService.isShowLeftArrow(this.offseterElem);
    }

    get isShowRightArrow():boolean{
        return this.scrollService.isShowRightArrow(this.offseterElem)
    }*/

    private courseItemcode() {
        return get(this.item, 'pnx.display.crsinfo');
    }

    private scrollList() {
        this.intervalCounter++;
        this.distance += ((this.intervalCounter % 38) === 0 && this.distance < this.MAX_DISTANCE ? 1 : 0);

        if (this.scrollDirection === this.LEFT) {
            this.scrollElement[0].scrollLeft -= this.distance;
        }
        if (this.scrollDirection === this.RIGHT) {
            this.scrollElement[0].scrollLeft += this.distance;
        }

        if (this.scrollElement[0].scrollLeft >= this.dynamicMoreLikeThisItems.rightScrollLimit || this.scrollElement[0].scrollLeft <= this.dynamicMoreLikeThisItems.leftScrollLimit) {
            this.$interval.cancel(this.interval);
        }
    }

    private scrollLeftMouseDown() {
        this.$interval.cancel(this.interval); //if there is a scrolling action in progress cancel it
        this.intervalCounter = 0;
        this.distance = this.INITIAL_DISTANCE;
        this.scrollDirection = this.LEFT;
        this.clickTimeOut = this.$timeout(() => {
            this.interval = this.$interval(() => {
                this.scrollList()
            }, 5);
        }, this.CLICK_TIME);

    }

    private scrollRightMouseDown() {
        this.$interval.cancel(this.interval); //if there is a scrolling action in progress cancel it
        this.intervalCounter = 0;
        this.distance = this.INITIAL_DISTANCE;
        this.scrollDirection = this.RIGHT;
        this.clickTimeOut = this.$timeout(() => {
            this.interval = this.$interval(() => {
                this.scrollList()
            }, 5);
        }, this.CLICK_TIME);
    }


    private scrollMouseUp() {
        this.sendScrollDirectionBeacon(this.scrollDirection);
        if (this.$timeout.cancel(this.clickTimeOut)) { //If it was a quick click scroll a set distance
            this.smoothScrollClick();
        } else {
            this.$interval.cancel(this.interval);
        }
    }

    // External links button
    public toggleFacet(event) {
        let elem = event.target;
        this.externalLinksCollapse = !this.externalLinksCollapse;
        elem.setAttribute('aria-expanded', this.externalLinksCollapse);
    }

    public isExternalBtnShown() {
        return this.sameByFields.length > 6;
    }

    public getExpandAriaLabel() {
        return this.getLabelByField('nui.aria.moreFromTheSame');
    }

    public getExpandTabType() {
        return this.getLabelByField('nui.brief.results.tabs');
    }

    private getLabelByField(labelPrefix: string) {
        let label = '';
        if (this.sameByField === 'crs') {
            label = labelPrefix + '.expandCourses';
        } else if (this.sameByField === 'col') {
            label = labelPrefix + '.expandCollections';
        }
        return label;
    }

    public colTitle(pids) {
        let promises = [];
        pids.forEach((pid) => {
            promises.push(this.collectionDiscoveryService.getSubColWithPath(pid, this.institution));
        });
        return promises;
    }

    private moreLikeThisStateParams(pid): ICollectionPathObject {
        let collectionName =  get(pid, 'value.name') || get(pid, 'value.title');
        let params = {
            level: get(pid, 'level'),
            name: collectionName,
            pid: get(pid, 'value.pid.value'),
            tooltip: this.$translate.instant('nui.aria.moreFromTheSame.collection', {collectionName: collectionName})
        };
        return params;
    }

    @beacon({'p':'moreFromTheSame', 'op':'recordMoreFromTheSame'})
    private sendMoreFromTheSameItemBeacon(recordId){
    }
    
    private navigateToItemFullView(moreFromTheSameItem) {
        this.sendMoreFromTheSameItemBeacon(moreFromTheSameItem.recordId);
        this.moreLikeThisService.navigateToItemFullView(moreFromTheSameItem);
    }

    public getStateName() {
        return this.moreLikeThisService.getStateName();
    }

    private getItemFullViewParams(moreLikeThisItem) {
        return this.moreLikeThisService.getItemFullViewParams(moreLikeThisItem);
    }

    /*@beacon({ 'p': 'brief', 'op': 'linktoPath' })
    private runCollectionDiscoveryBeacon() {}*/

    private sortByName(sameByFields: any[]): any[]{
        return orderBy(sameByFields, [field => field ? field.name.toLowerCase() : field.name], ['asc']);
    }


    closeDialog(){
        this.$mdDialog.hide();
    }

// More Like This Beacon - Still need to develop and check if works --- End
}


class DynamicMoreLikeThisItems {
    public currentIndex: number = START_INDEX;
    private params: any;
    private leftLimitIndex: number;
    public leftFinalIndex: number;
    private rightLimitIndex: number;
    public rightFinalIndex: number;
    public rightScrollLimit: number;
    public leftScrollLimit: number;
    private offset: number;
    private isLoading: boolean;
    public items : Array<PrimoResponse.IDoc> =[];
    constructor(private item: PrimoResponse.IDoc, private virtualBrowseService: VirtualBrowseService, private scrollElement: JQuery, private sameByField: string, private configurationUtil: ConfigurationUtil, private moreLikeThisService: MoreLikeThisService, private totalItems: number, private firstMoreLikeThisItems: Array<PrimoResponse.IDoc>) {
        this.params ={};
        this.params.position = 'START';
        this.isLoading = true;
        
        //this.rightLimitIndex = START_INDEX + this.items.length;
        //this.leftLimitIndex = START_INDEX;
        this.leftFinalIndex = START_INDEX;
        this.rightFinalIndex = this.totalItems;

        this.offset = 0;

        this.handleResponse({docs: firstMoreLikeThisItems}); 
    }

    public getLength() {
        return this.totalItems - 1;
    }

    public getItemAtIndex(index) {
        if (index < this.leftFinalIndex) {
            return undefined;
        }

        if (index > this.rightFinalIndex) {
            return undefined;
        }

        if (index <= this.rightLimitIndex  && index >= this.leftLimitIndex) {
            return this.items[index - this.leftLimitIndex];
        }
        if (this.isLoading) { //if API already called don't call again
            return undefined;
        }
        if (index > this.rightLimitIndex) {
            this.params.position = 'RIGHT';
        }
        if (index < this.leftLimitIndex) {
            this.params.position = 'LEFT';
        }
        this.isLoading = true; //set this flag to true so we don't try to call API more than once
        //after initial bulk get 20 items each api call. In Primo, bulks must be the same size.
        //before changing this value, check if results in virtual browse in primo are correct.

        this.offset = this.offset + getResultsBulkSize();
        this.moreLikeThisService.getItemsForSameField(this.item, this.sameByField, this.offset).then((response) => {
            this.handleResponse(response.data)
        });
        
        return undefined;
    }

    public handleResponse(data) {
        let itemsUnfiltered = get(data, 'data.docs') || get(data, 'docs');
        if(!itemsUnfiltered){
            itemsUnfiltered = [];
        }
        let items = this.moreLikeThisService.parseResponse(data, this.item);
        if (!this.leftLimitIndex) {
            this.leftLimitIndex = 0;
        }
        if (!this.rightLimitIndex) {
            this.rightLimitIndex = itemsUnfiltered.length;
            this.items = items;

        }
        switch (this.params.position) {
            case 'RIGHT':
                this.rightLimitIndex = this.rightLimitIndex + itemsUnfiltered.length;

                this.items = this.items.concat(items);
                break;
            case 'LEFT':
                this.leftLimitIndex = this.leftLimitIndex - itemsUnfiltered.length;
                this.items = items.concat(this.items);
        }
        this.isLoading = false; // signal that API call has finished
    }

    //the following method calculates the staring index for the virtual repeat. We want to put the selected record at the center of the list to start off.
    //We also take care of edge cases such as the lowest call number of highest call number
    private calculateStartIndex(centerIndex, numOfItems): number {
        let numOfItemsInViewPort = Math.floor(this.scrollElement[0].offsetWidth / ITEM_WIDTH);
        let numOfItemsLeftOfCenter = Math.floor((numOfItemsInViewPort - 1) / 2);
        let numOfItemsRightOfCenter = numOfItemsInViewPort - 1 - numOfItemsLeftOfCenter;
        if ((numOfItems - centerIndex) <= numOfItemsRightOfCenter) {
            return START_INDEX - numOfItemsInViewPort + (numOfItems - centerIndex) + 1;
        }
        if (centerIndex <= numOfItemsLeftOfCenter) {
            return START_INDEX - numOfItemsLeftOfCenter + centerIndex;
        }
        return START_INDEX - numOfItemsLeftOfCenter;
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/moreLikeThis/moreLikeThis.directive.ts